<script setup>
import { computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import Nav from './components/nav.vue';
import HeroSection from './components/HeroSection.vue';
import TrustBar from './components/TrustBar.vue';
import CourseSection from './components/CourseSection.vue';
import MasterSection from './components/MasterSection.vue';
import FitSection from './components/FitSection.vue';
import GallerySection from './components/GallerySection.vue';
import ClassSection from './components/ClassSection.vue';
import NotesSection from './components/NotesSection.vue';
import FeedbackSection from './components/FeedbackSection.vue';
import StepsSection from './components/StepsSection.vue';
import FaqSection from './components/FaqSection.vue';
import FinalCta from './components/FinalCta.vue';
import Footer from './components/Footer.vue';
import { finalCtaData } from '../config/pageData.js';
import { logEvent } from '@/utils/firebase.js';
import { getButtonUrl } from '@/utils/channelConfig.js';
import { getLogEventClickParams } from '@/utils/logEventParams';

const route = useRoute();
// 底部固定條：手機首屏免滑動即可見報名入口
const bottomUrl = computed(() => getButtonUrl('formSubmit', route.query.channel));

onMounted(() => {
  logEvent('mobile_fengsuids_uv');
  logEvent('mobile_fengsuids_pv');
});
</script>

<template>
  <div class="m-home">
    <Nav />
    <HeroSection />
    <TrustBar />
    <div id="course">
      <CourseSection />
    </div>
    <MasterSection />
    <FitSection />
    <GallerySection />
    <ClassSection />
    <NotesSection />
    <FeedbackSection />
    <StepsSection />
    <FaqSection />
    <FinalCta />
    <Footer />

    <!-- 底部固定報名條 -->
    <div class="m-fixed-bar">
      <a
        :href="bottomUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="m-fixed-btn"
        @click="logEvent('mobile_fengsuids_bottombar_click', getLogEventClickParams())"
      >
        {{ finalCtaData.btnText }}
      </a>
    </div>
  </div>
</template>

<style scoped lang="scss">
.m-home {
  width: 100%;
  font-family: 'Noto Sans TC', 'PingFang TC', 'Microsoft JhengHei', sans-serif;
  background: #f7f3ea;
  color: #2c2a25;
  line-height: 1.7;
}

.m-fixed-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 90;
  padding: 16px 32px calc(32px + env(safe-area-inset-bottom));
  // 只保留浮動按鈕，不要整條背景色
  pointer-events: none;
}

.m-fixed-btn {
  display: block;
  text-align: center;
  background: #c9a25e;
  color: #16241d;
  font-size: 30px;
  font-weight: 700;
  letter-spacing: 2px;
  border-radius: 999px;
  padding: 18px 0;
  text-decoration: none;
  box-shadow: 0 6px 18px rgba(22, 36, 29, 0.28);
  animation: m-fixed-pulse 1.6s ease-in-out infinite;
  pointer-events: auto;
}

@keyframes m-fixed-pulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.04);
  }
}
</style>
